exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#mw .mw-flexi-modal>md-toolbar.view-nld__toolbar{background:#000}.view-nld__toolbar-title{color:#fff;margin-left:10px}.view-nld__toolbar-button{color:#fff}.view-nld__iframe{width:100%;border:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsletter-distributions/view-newsletter-distribution/view-newsletter-distribution.component.css
 ** module id = 44
 ** module chunks = 0 1
 **/